import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import rootReducer from "./store/reducers/rootReducer";
import { Provider } from "react-redux";
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <Provider store={rootReducer}>
    <App />
  </Provider>,
  document.getElementById("root")
);
serviceWorker.register();